export class AllocationRuleDTO{

    public id!: number;
    public description!: string;
    public sourceFieldReference!: string;
    public sourceFieldValue!: string;
    public destinationFieldReference!: string;
    public destinationFieldValue!: string;
    public allocationPercentage!: number;
    public allocationMethod!: number;
    public weightFieldReferences!: string;
}